/**
 * External Dependencies
 */
import classnames from 'classnames';
import apiFetch from '@wordpress/api-fetch';

const { assign } = lodash;
const { __ } = wp.i18n;
const { Fragment } = wp.element;
const { addFilter } = wp.hooks;
const { TextControl, PanelBody, SelectControl } = wp.components;
const { createHigherOrderComponent } = wp.compose;
const { InspectorControls } = wp.editor;



let wpDxpRuleOptions = [];
wpDxpRuleOptions.push({ value: null, label: '-- Select --' });

apiFetch({ path: '/wp-dxp/v1/rules' }).then( response => {
	response.data.forEach(function (rule) {
	  	wpDxpRuleOptions.push({ value: rule.id, label: rule.name });
	});
}).catch( err => {
    console.log(err);
});

let wpDxpActionOptions = [];
wpDxpActionOptions.push({ value: 'show', label: 'Show Block' });
wpDxpActionOptions.push({ value: 'hide', label: 'Hide Block' });



// See richardtape.com/?p=348

/**
 * Override the default edit UI to include a new block inspector control for
 * adding our custom control.
 *
 * @param {function|Component} BlockEdit Original component.
 *
 * @return {string} Wrapped component.
 */
export const addWpDxpBlockControls = createHigherOrderComponent( ( BlockEdit ) => {

    return ( props ) => {

		const {
			name,
			attributes,
			setAttributes,
			isSelected,
		} = props;

		const {
			visibleOnMobile,
			wpDxpRule,
			wpDxpAction,
		} = attributes;

		console.log(wpDxpAction);

        // If this block supports scheduling and is currently selected, add our UI
        if ( isValidBlockType( props.name ) && props.isSelected ) {
            return (
                <Fragment>
                    <BlockEdit { ...props } />
                    <InspectorControls>
                        <PanelBody title={ __( 'WP-DXP' ) }>
							<SelectControl
						        label={ __( 'When this rule is met:' ) }
						        name={ 'wpDxpRule' }
						        value={ wpDxpRule } // e.g: value = [ 'a', 'c' ]
						        onChange={ (wpDxpRule) => setAttributes( {  wpDxpRule: wpDxpRule } ) }
						        options={ wpDxpRuleOptions }
						    />
							<SelectControl
						        label={ __( 'Then take the following action:' ) }
						        name={ 'wpDxpAction' }
						        value={ wpDxpAction } // e.g: value = [ 'a', 'c' ]
						        onChange={ (wpDxpAction) => setAttributes( {  wpDxpAction: wpDxpAction } ) }
						        options={ wpDxpActionOptions }
						    />
                        </PanelBody>
                    </InspectorControls>
                </Fragment>
            );
        }

        return <BlockEdit { ...props } />;
    };
}, 'addWpDxpBlockControls' );

addFilter( 'editor.BlockEdit', 'wp-dxp/controls', addWpDxpBlockControls );

// See richardtape.com/?p=348

/**
 * Is the passed block name one which supports our custom field?
 *
 * @param {string} name The name of the block.
 */
function isValidBlockType( name ) {

	return true;

    const validBlockTypes = [
		null,
		'core/freeform',
		'core/heading',
		'core/html',
		'core/list',
		'core/media-text',
		'core/paragraph',
		'core/preformatted',
		'core/pullquote',
		'core/quote',
		'core/table',
		'core/verse',
    ];

    return validBlockTypes.includes( name );

}// end isValidBlockType()

// See https://richardtape.com/?p=348

/**
 * Filters registered block settings, extending attributes with our custom data.
 *
 * @param {Object} settings Original block settings.
 *
 * @return {Object} Filtered block settings.
 */
export function addAttribute( settings ) {

	// If this is a valid block
	if ( isValidBlockType( settings.name ) ) {

		// Use Lodash's assign to gracefully handle if attributes are undefined
		settings.attributes = assign( settings.attributes, {
			wpDxpRule:{
				type: 'string',
				default: null,
			},
			wpDxpAction:{
				type: 'string',
				default: null,
			},
		} );
	}

	return settings;

}// end addAttribute()

/**
 * Override props assigned to save component to inject our custom data.
 * This is only done if the component is a valid block type.
 *
 * @param {Object} extraProps Additional props applied to save element.
 * @param {Object} blockType  Block type.
 * @param {Object} attributes Current block attributes.
 *
 * @return {Object} Filtered props applied to save element.
 */
export function addSaveProps( extraProps, blockType, attributes ) {

	// If the current block is valid, add our prop.
	if ( isValidBlockType( blockType.name ) ) {
		extraProps.wpDxpRule = attributes.wpDxpRule;
		extraProps.wpDxpAction = attributes.wpDxpAction;
	}

	return extraProps;

}// end addSaveProps()

addFilter( 'blocks.registerBlockType', 'wp-dxp/add-attr', addAttribute );
//addFilter( 'blocks.getSaveContent.extraProps', 'wp-dxp/add-props', addSaveProps );